/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigScopeDetailsForGcpServiceAccount extends models.LockConfigScopeDetailsBaseForServiceAccount {
    constructor() {
        super();
        this.setDiscriminator("LockConfigScopeDetailsForGcpServiceAccount");
    }

    getFixupPrototypeFunction() { return LockConfigScopeDetailsForGcpServiceAccount.fixupPrototype; }

    static newInstance(model: Partial<LockConfigScopeDetailsForGcpServiceAccount>): LockConfigScopeDetailsForGcpServiceAccount {
        let obj = Object.assign(new LockConfigScopeDetailsForGcpServiceAccount(), model);
        LockConfigScopeDetailsForGcpServiceAccount.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigScopeDetailsForGcpServiceAccount>): LockConfigScopeDetailsForGcpServiceAccount {
        if (!model) return null;
        return LockConfigScopeDetailsForGcpServiceAccount.newInstance(<LockConfigScopeDetailsForGcpServiceAccount> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigScopeDetailsForGcpServiceAccount) {
        if (!obj) return;

        models.LockConfigScopeDetailsForGcpServiceAccount.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigScopeDetailsForGcpServiceAccount): boolean {
        if (models.LockConfigScopeDetailsBaseForServiceAccount.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, LockConfigScopeDetailsForGcpServiceAccount.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.zones) {
            for (let val of this.zones) {
                models.GcpZone.fixupPrototype(val);
            }
        }
    }

    /**
     * List Gcp zones of cloud account
     */
    zones: Array<models.GcpZone>;

}
